import { Modal } from '@trackman/web-shared-components';
import { TaggingFlowWrapper } from 'pages/Tagging/components/TaggingFlow/TaggingFlowStyles';
import { TagCatcherThrowsWrapper } from 'pages/Tagging/components/TaggingFlow/components/TagCatcherThrows/TagCatcherThrowsStyles';
import React from 'react';
import styled from 'styled-components';
import { lightgrey } from 'styles/Colors';

export const StyledModal = styled((props) => <Modal {...props} />)`
  &&& {
    .MuiPaper-root {
      width: 445px !important;
    }
  }
`;

export const Content = styled.div`
  padding-bottom: 25px;
  overflow-x: hidden;
`;

export const Editor = styled.div`
  ${TaggingFlowWrapper} {
    ${TagCatcherThrowsWrapper} {
      width: 100%;
    }
  }
  .catcher-throws-flow.review,
  .fielding-sequence-flow.review {
    height: 460px;
  }
`;

export const Footer = styled.div`
  border-top: 1px solid rgba(${lightgrey}, 0.25);
  margin-top: 8px;
  padding-top: 8px;
  display: flex;
  justify-content: flex-end;
`;
